import { Injectable } from '@angular/core';
import { HttpRequest, HttpInterceptor, HttpHandler } from '@angular/common/http';
import { CustomerAuthService } from '../../pages/my-account/services/customer-auth.service';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {
  constructor(private customerAuthService: CustomerAuthService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler) {
    if (req.headers.get('Use-Authorization')) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${this.customerAuthService.getCurrentToken().token}`
        }
      });
    }
    return next.handle(req);
  }
}
